import createPermission from 'permissions/createPermission'
import panelsList from 'permissions/panels/list'

const upgrade = createPermission('unit.firmware.upgrade')

export default upgrade
export const upgradeList = createPermission(upgrade, panelsList)